module.exports = __webpack_public_path__ + "static/media/Homemobile.9fe53565.png";